import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"
import { ThemeSwitcherProvider } from "react-css-theme-switcher"
import React from "react"

import store from "./store"
import Layouts from "./layouts"
import "./lang"
import history from "./history"
import { THEME_CONFIG } from "./configs/AppConfig"

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
}

const environment = process.env.NODE_ENV

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          <ThemeSwitcherProvider
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
            themeMap={themes}
          >
            <Layouts />
          </ThemeSwitcherProvider>
        </BrowserRouter>
      </Provider>
    </div>
  )
}

export default App
